module.exports = __webpack_public_path__ + "img/loading.d0416241.gif";